import { Component } from '@angular/core';

@Component({
    selector: 'app-layout-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  get fullYear(): number {
    return (new Date().getFullYear());
  }
}
